import type { ButtonHTMLAttributes, ReactNode } from "react";

type AuthSubmitButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  icon?: string;
  busyLabel?: string;
  isBusy?: boolean;
};

export function AuthSubmitButton({
  children,
  icon = "arrow_forward",
  busyLabel,
  isBusy = false,
  ...props
}: AuthSubmitButtonProps) {
  return (
    <button
      {...props}
      className={`auth-button ${props.className ?? ""}`.trim()}
      disabled={isBusy || props.disabled}
      data-oid="39h1frb"
    >
      <span data-oid="vzrmbye">
        {isBusy && busyLabel ? busyLabel : children}
      </span>
      <span className="material-symbols-outlined" data-oid=".533j35">
        {isBusy ? "progress_activity" : icon}
      </span>
    </button>
  );
}
